import { IconColors } from 'Icons';
import { IconProps } from 'Icons/IconProps';
import { FlexWrapper } from 'Shared/FlexWrapper';
import React from 'react';
import dashboardStyles from '../DashboardLinks.module.css';
import styles from './QuickActionModal.module.css';

interface QuickActionButtonProps {
    Icon: React.FC<IconProps>;
    setShow: (show: boolean) => void;
    buttonText: string;
    strokeWidth?: string;
}

const QuickActionButton = ({ Icon, setShow, buttonText, strokeWidth }: QuickActionButtonProps): JSX.Element => (
    <button onClick={() => setShow(true)} type="button" className={styles.ActionButton}>
        <FlexWrapper
            align="center"
            justify="center"
            column
            className={`${styles.IconContainer} ${dashboardStyles.BubbleLink}`}
        >
            <Icon
                aspect="3rem"
                color={IconColors.White}
                style={{
                    strokeWidth: strokeWidth || '3px',
                }}
            />
            <p className={styles.IconText} style={{ color: IconColors.White }}>
                {buttonText}
            </p>
        </FlexWrapper>
    </button>
);

export default QuickActionButton;
